import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
  AnyObject,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';

export type CommentDeleteData = AnyObject;

export type CommentDeleteResponse = CommentDeleteData;

export interface CommentDelete {
  id: string;
}

export const commentDelete = (payload: CommentDelete): Action<CommentDelete> => ({
  type: actions.commentDeleteTrigger.toString(),
  payload,
});

export const commentDeleteClear = (): Action => ({
  type: actions.commentDeleteClear.toString()
});

export const commentDeleteErrorClear = (): Action => ({
  type: actions.commentDeleteErrorReset.toString()
});

export function* commentDeleteRequestSaga({ payload }: Action<CommentDelete>) {
  yield put({
    type: actions.commentDeleteStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.commentDeleteError.toString(),
      payload: {
        message: 'CommentDelete: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}comments/${id}`,
    {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json', },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CommentDeleteData, CommentDeleteResponse>(
    response,
    actions.commentDeleteSuccess.toString(),
    actions.commentDeleteError.toString(),
    false,
    (commentDeleteData) => commentDeleteData,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.commentDeleteTrigger.toString(),
    defaultProcessingSaga(
      commentDeleteRequestSaga,
      {
        error: actions.commentDeleteError.toString(),
        locationCancel: actions.commentDeleteClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.commentDeleteSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }

    // yield put({
    //   type: actions.commentDeleteClear.toString(),
    // });
  });

  yield takeLatest(actions.commentDeleteError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.commentDeleteErrorReset.toString(),
    });
  });
}
